export let NUMBER_OF_COLUMNS = /*#__PURE__*/function (NUMBER_OF_COLUMNS) {
  NUMBER_OF_COLUMNS[NUMBER_OF_COLUMNS["FREE_FLOW"] = 0] = "FREE_FLOW";
  NUMBER_OF_COLUMNS[NUMBER_OF_COLUMNS["ONE"] = 1] = "ONE";
  NUMBER_OF_COLUMNS[NUMBER_OF_COLUMNS["TWO"] = 2] = "TWO";
  NUMBER_OF_COLUMNS[NUMBER_OF_COLUMNS["THREE"] = 3] = "THREE";
  return NUMBER_OF_COLUMNS;
}({});
//# sourceMappingURL=options-layout-constants.js.map